import {Platform} from 'react-native';
import Styles from 'src/components/Styles';

export function getHeaderBackground(content: JSX.Element): JSX.Element {
  return content;
}

export function headerFontSize(): number {
  return Styles.Fonts.f9;
}

export function subHeaderFontSize(): number {
  return Styles.Fonts.f7;
}

export function headerContainerStyleDescriptor(): {
  [key: string]: {[key: string]: number | string};
} {
  return {
    container: {
      flex: 1,
      flexDirection: 'column',
      backgroundColor: Styles.tabBarBackgroundColor,
    },
    safeArea: {
      backgroundColor: Styles.darkBlueRevolveColor,
    },
    headerTextStyle: {
      textAlign: 'left',
      fontSize: headerFontSize(),
      color: Styles.white,
      fontWeight: '400',
      textTransform: 'uppercase',
      fontFamily: Styles.FontFamily.comodoVintage,
      height: 34,
      verticalAlign: 'middle',
      marginTop: Platform.OS === 'ios' ? Styles.Spacing.m1 : Styles.Spacing.m0,
    },
  };
}

export function subHeaderContainerStyleDescriptor(): {
  [key: string]: {[index: string]: number | string};
} {
  return {
    subHeaderTextStyle: {
      fontSize: subHeaderFontSize(),
      fontWeight: '700',
    },
  };
}

export function getBackIconColor(_transparent: boolean): string {
  return '#A4DB57';
}

export default {
  getHeaderBackground,
  headerContainerStyleDescriptor,
  getBackIconColor,
  headerFontSize,
  subHeaderFontSize,
  subHeaderContainerStyleDescriptor,
};
